<ion-content>
  <div class="content-wrapper">
    <img [src]="ticketImageUrl" class="ticket-img" />
    <p class="note">
      You’re NOT paying the price displayed for this ticket (retail price), but reduced syndicated price
    </p>
    <h3 class="back-label"><span (click)="back()">← Back</span></h3>
  </div>
</ion-content>
